(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/app/app.view.html',
    '<header-component></header-component>\n' +
    '<div class="container app-dashboard">\n' +
    '  <div ng-view></div>\n' +
    '</div>\n' +
    '<footer-component></footer-component>\n' +
    '');
}]);
})();

(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/admin/dashboard/dashboard.view.html',
    '<div class="jumbotron">\n' +
    '  <h1 class="display-4">User Details App</h1>\n' +
    '  <p class="lead">\n' +
    '    Welcome to the Application Dashboard!\n' +
    '  </p>\n' +
    '  <a class="btn btn-primary btn-lg" href="#!/users" role="button"\n' +
    '    >Go to Users Details</a\n' +
    '  >\n' +
    '</div>\n' +
    '');
}]);
})();

(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/common/footer-component/footer-component.view.html',
    '<footer>\n' +
    '  <div class="container">\n' +
    '    <div class="row">\n' +
    '      <div class="col-md-12">\n' +
    '        AngularJS Application &copy; 2019.\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</footer>\n' +
    '');
}]);
})();

(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/common/header-component/header-component.view.html',
    '<header>\n' +
    '  <nav class="navbar navbar-expand-lg navbar-light bg-light">\n' +
    '    <div class="container">\n' +
    '      <a class="navbar-brand" href="#">Users Details App</a>\n' +
    '      <button\n' +
    '        class="navbar-toggler"\n' +
    '        type="button"\n' +
    '        data-toggle="collapse"\n' +
    '        data-target="#navbarNavDropdown"\n' +
    '        aria-controls="navbarNavDropdown"\n' +
    '        aria-expanded="false"\n' +
    '        aria-label="Toggle navigation"\n' +
    '      >\n' +
    '        <span class="navbar-toggler-icon"></span>\n' +
    '      </button>\n' +
    '      <div class="collapse navbar-collapse" id="navbarNavDropdown">\n' +
    '        <ul class="navbar-nav">\n' +
    '          <li class="nav-item">\n' +
    '            <a class="nav-link" href="#!/">Home</a>\n' +
    '          </li>\n' +
    '          <li class="nav-item">\n' +
    '            <a class="nav-link" href="#!/users">Users</a>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '\n' +
    '        <ul class="navbar-nav ml-auto">\n' +
    '          <li class="nav-item active">\n' +
    '            <a\n' +
    '              class="nav-link"\n' +
    '              href="https://github.com/AbdelrahmanSE/angularjs-users-details"\n' +
    '              target="_blank"\n' +
    '              >Github Repo</a\n' +
    '            >\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </nav>\n' +
    '</header>\n' +
    '');
}]);
})();

(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/user/users/users.view.html',
    '<div class="row">\n' +
    '  <div class="col-md-8">\n' +
    '    <h2>Users</h2>\n' +
    '  </div>\n' +
    '  <div class="col-md-4 text-right">\n' +
    '    <span class="font-weight-bold" ng-if="getSelectedUsers().length">\n' +
    '      {{ getSelectedUsers().length }} selected\n' +
    '    </span>\n' +
    '    <button type="button" class="btn btn-danger" ng-click="deleteSelected()" ng-disabled="!isUserSelected()">\n' +
    '      Delete\n' +
    '    </button>\n' +
    '    <button type="button" class="btn btn-warning" ng-click="downloadSelected()" ng-disabled="!isUserSelected()">\n' +
    '      Download\n' +
    '    </button>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<table class="table">\n' +
    '  <thead class="thead-dark">\n' +
    '    <tr>\n' +
    '      <th scope="col">#</th>\n' +
    '      <th scope="col"></th>\n' +
    '      <th scope="col">Name</th>\n' +
    '      <th scope="col">Email</th>\n' +
    '      <th scope="col">Country</th>\n' +
    '      <th scope="col" class="text-center">Actions</th>\n' +
    '    </tr>\n' +
    '  </thead>\n' +
    '  <tbody>\n' +
    '    <tr user-row ng-repeat="user in getUsersPage()" user="user" ng-class="user.selected ? \'selected\' : \'\'"></tr>\n' +
    '  </tbody>\n' +
    '</table>\n' +
    '\n' +
    '<nav aria-label="Page navigation users">\n' +
    '  <ul class="pagination justify-content-center">\n' +
    '    <li class="page-item" ng-class="currentPage === 0 ? \'disabled\' : \'\'">\n' +
    '      <button class="page-link" ng-click="previousPage()">Previous</button>\n' +
    '    </li>\n' +
    '    <li class="page-item disabled">\n' +
    '      <span class="page-link">{{ currentPage + 1 }}</span>\n' +
    '    </li>\n' +
    '    <li class="page-item" ng-class="isLastPage() ? \'disabled\' : \'\'">\n' +
    '      <button class="page-link" ng-click="nextPage()">Next</button>\n' +
    '    </li>\n' +
    '  </ul>\n' +
    '</nav>\n' +
    '\n' +
    '<user-show></user-show>\n' +
    '');
}]);
})();

(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/user/users-detials/users-detials.view.html',
    '<a href="#!/users">< Back to Users</a>\n' +
    '<h2>Edit {{ user.firstName }} Details</h2>\n' +
    '\n' +
    '<div class="row">\n' +
    '  <div class="col-md-6">\n' +
    '    <form name="editUser">\n' +
    '      <div class="form-group">\n' +
    '        <label for="firstName">First Name</label>\n' +
    '        <input\n' +
    '          type="text"\n' +
    '          class="form-control"\n' +
    '          id="firstName"\n' +
    '          ng-model="user.firstName"\n' +
    '          name="firstName"\n' +
    '          placeholder="Enter first name"\n' +
    '          required\n' +
    '        />\n' +
    '        <small\n' +
    '          ng-show="editUser.firstName.$dirty && !editUser.firstName.$valid"\n' +
    '          class="form-text text-danger"\n' +
    '          >Please enter a value for first name.</small\n' +
    '        >\n' +
    '      </div>\n' +
    '      <div class="form-group">\n' +
    '        <label for="lastName">Last Name</label>\n' +
    '        <input\n' +
    '          type="text"\n' +
    '          class="form-control"\n' +
    '          id="lastName"\n' +
    '          ng-model="user.lastName"\n' +
    '          name="lastName"\n' +
    '          placeholder="Enter last name"\n' +
    '          required\n' +
    '        />\n' +
    '        <small ng-show="editUser.lastName.$dirty && !editUser.lastName.$valid" class="form-text text-danger"\n' +
    '          >Please enter a value for last name.</small\n' +
    '        >\n' +
    '      </div>\n' +
    '      <div class="form-group">\n' +
    '        <label for="email">Email</label>\n' +
    '        <input\n' +
    '          type="text"\n' +
    '          class="form-control"\n' +
    '          id="email"\n' +
    '          ng-model="user.email"\n' +
    '          name="email"\n' +
    '          placeholder="Enter email"\n' +
    '          required\n' +
    '          ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\'\n' +
    '        />\n' +
    '        <small ng-show="editUser.email.$dirty && !editUser.email.$valid" class="form-text text-danger"\n' +
    '          >Please enter a valid email address.</small\n' +
    '        >\n' +
    '      </div>\n' +
    '      <button type="button" class="btn btn-primary" ng-disabled="!editUser.$valid" ng-click="saveUser()">Save</button>\n' +
    '      <button type="button" class="btn btn-danger" ng-click="checkEdits()">Cancel</button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div\n' +
    '  class="modal fade"\n' +
    '  id="cancelUserEdit"\n' +
    '  tabindex="-1"\n' +
    '  role="dialog"\n' +
    '  aria-labelledby="cancelUserEditTitle"\n' +
    '  aria-hidden="true"\n' +
    '>\n' +
    '  <div class="modal-dialog modal-dialog-centered" role="document">\n' +
    '    <div class="modal-content">\n' +
    '      <div class="modal-header">\n' +
    '        <h5 class="modal-title" id="cancelUserEditTitle">Cancel Edits</h5>\n' +
    '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n' +
    '          <span aria-hidden="true">&times;</span>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="modal-body">\n' +
    '        Are you sure to cancel the edits for the user?\n' +
    '      </div>\n' +
    '      <div class="modal-footer">\n' +
    '        <button type="button" class="btn btn-danger" ng-click="cancelEdits()">Yes</button>\n' +
    '        <button type="button" class="btn btn-primary" data-dismiss="modal">No</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);
})();

(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/user/users/user-row/user-row.view.html',
    '<th scope="row">{{ user.id }}</th>\n' +
    '<td><input type="checkbox" ng-model="user.selected" /></td>\n' +
    '<td>{{ user.firstName }} {{ user.lastName }}</td>\n' +
    '<td>{{ user.email }}</td>\n' +
    '<td>{{ user.country }}</td>\n' +
    '<td class="text-center">\n' +
    '  <button type="button" class="btn btn-primary" ng-click="showUser()">Show</button>\n' +
    '  <button type="button" class="btn btn-danger" ng-click="deleteUser()">Delete</button>\n' +
    '  <button type="button" class="btn btn-secondary" ng-click="editUser()">Edit</button>\n' +
    '</td>\n' +
    '');
}]);
})();

(function(module) {
try {
  module = angular.module('UsersApp.Partials');
} catch (e) {
  module = angular.module('UsersApp.Partials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('/modules/user/users/user-show/user-show.view.html',
    '<div\n' +
    '  class="modal fade"\n' +
    '  id="userDetailsModal"\n' +
    '  tabindex="-1"\n' +
    '  role="dialog"\n' +
    '  aria-labelledby="userDetailsModalTitle"\n' +
    '  aria-hidden="true"\n' +
    '>\n' +
    '  <div class="modal-dialog modal-dialog-centered" role="document">\n' +
    '    <div class="modal-content">\n' +
    '      <div class="modal-header">\n' +
    '        <h5 class="modal-title" id="userDetailsModalTitle">{{ UserData.shownUser.firstName }} Details</h5>\n' +
    '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n' +
    '          <span aria-hidden="true">&times;</span>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '      <div class="modal-body">\n' +
    '        {{ UserData.shownUser.firstName }} {{ UserData.shownUser.lastName }}, age:{{ calculateAge() }}\n' +
    '      </div>\n' +
    '      <div class="modal-footer">\n' +
    '        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);
})();
